import { useSelector } from 'react-redux';
import DataTableGrid from '../../../../components/common/DataTableGrid';
import ExportTable from '../../../../components/common/export-table/ExportTable';
import './manufacturer-stats.scss';
import { selectManufacturerInstallation } from '../../RunlifeDarshboardSlice';
import { useMemo } from 'react';
import { formatNumber } from '../../../../utilities/Helpers';

const RunLifeManufacturerStats: React.FC = () => {
  const data = useSelector(selectManufacturerInstallation);
  const columns = useMemo(() => {
    const cols: any[] = [
      {
        Header: 'Statistic',
        accessor: 'stats',
        disableFilters: true,
        Cell: ({ value, row }: { value: any; row: any }) => {
          // Extra bold for header rows
          if (row.original?.key === '') {
            return <div style={{ fontWeight: 800, fontSize: '15px' }}>{value}</div>;
          }
          return <div>{value}</div>;
        },
      },
    ];
    data.forEach((item) =>
      cols.push({
        Header: item.Manufacturer,
        accessor: item.Manufacturer,
        disableFilters: true,
        Cell: ({ value, row }: { value: any; row: any }) => {
          // For bold header rows, show empty cell
          if (row.original?.key === '') {
            return <div></div>;
          }
          const num = parseFloat(formatNumber(value, 1));
          if (value === undefined || value === null || isNaN(num)) {
            return <div>-</div>;
          }
          return <div>{num}</div>;
        },
      }),
    );
    return cols || [];
  }, [data]);
  const tableData = useMemo(() => {
    let rows: any[] = [
      { stats: 'Total installations', key: 'TotalInstallations' },
      { stats: 'Total running units', key: 'TotalRunningUnits' },
      { stats: 'Total failures', key: 'TotalFailures' },
      { stats: 'Total failures < 90', key: 'TotalFailuresWithinDays' },
      { stats: 'Total pulls (no failure)', key: 'TotalPulls' },
      { stats: 'Average runlife (days)', key: 'AverageRunlife' },
      { stats: 'Average runlife running (days)', key: 'AverageRunlifeRunningUnits' },
      { stats: 'Average runlife failed (days)', key: 'AverageRunlifeFailedUnits' },
      { stats: 'Average runlife pulled no failure (days)', key: 'AverageRunlifePulledUnits' },
      { stats: 'Mean time between failure (days)', key: 'MeanTimeBetweenFailure' },
      //Direct ESP failure
      { stats: 'Direct ESP failure', key: '' },
      { stats: 'Total failures', key: 'TotalDirectFailures' },
      { stats: 'Total failures < 90', key: 'TotalDirectFailuresWithinDays' },
      { stats: 'Average runlife failed (days)', key: 'AverageRunlifeDirectFailedUnits' },
      //Indirect ESP failure (Tubing)
      { stats: 'Indirect ESP failure (Tubing)', key: '' },
      { stats: 'Total failures', key: 'TotalTubingIndirectFailures' },
      { stats: 'Total failures < 90', key: 'TotalTubingIndirectFailuresWithinDays' },
      { stats: 'Average runlife failed (days)', key: 'AverageTubingRunlifeIndirectFailedUnits' },
      //Indirect ESP failure (Wellhead penetrator)
      { stats: 'Indirect ESP failure (Wellhead penetrator)', key: '' },
      { stats: 'Total failures', key: 'N/A' },
      { stats: 'Total failures < 90', key: 'N/A' },
      { stats: 'Average runlife failed (days)', key: 'N/A' },
      //Non ESP intervention
      { stats: 'Non ESP intervention', key: '' },
      { stats: 'Total pulls (no failure)', key: 'TotalPullsNonIntervention' },
      { stats: 'Average runlife pulled no failure (days)', key: 'AverageRunlifePulledNonInterventionUnits' },
    ];
    rows = rows.map((row) => {
      data.forEach((item: any) => {
        return (row[item.Manufacturer] = item[row.key]);
      });
      return row;
    });
    return rows || [];
  }, [data]);

  const exportColumns = useMemo(() => {
    const cols: any[] = [{ key: 'stats', header: 'Statistic', accessor: (row: any) => row.original?.stats || '' }];
    data.forEach((item: any) => {
      cols.push({
        key: item.Manufacturer,
        header: item.Manufacturer,
        accessor: (row: any) => {
          const value = row.original?.[item.Manufacturer] ?? '';
          if (row.original?.key === 'MeanTimeBetweenFailure') {
            const n = Number(value);
            return isNaN(n) ? value : parseFloat(formatNumber(n, 1));
          }
          return value;
        },
      });
    });
    return cols;
  }, [data]);
  const tableRowsForExport = Array.isArray(tableData) ? tableData.map((item: any) => ({ original: item })) : [];
  const rPermission = { canExport: true };

  return (
    <div className='manufacturer-stats-container'>
      <div className='manufacturer-stats-header'>Manufacturer statistics</div>
      <div className='wsw-divider' />
      <div className='runlife-export-button'>
        <ExportTable
          data={tableRowsForExport}
          fileName={'Manufacturer Statistics'}
          sheetName={'Manufacturer Stats'}
          columns={exportColumns}
          disabled={!tableRowsForExport || tableRowsForExport.length === 0}
          rPermission={rPermission}
        />
      </div>
      <div className='manufacturer-stats-table-container'>
        <DataTableGrid data={tableData} columns={columns as any} maxHeight='100%' disableSort={true} />
      </div>
    </div>
  );
};
export default RunLifeManufacturerStats;
